import { ImagesService } from 'service/images/imagesService';
import type { ICardImage } from '../types';

export const CardImageNoMetaBall = ({ asset }: ICardImage) => {
  if (!asset) {
    return null;
  }

  return (
    <div>
      <svg viewBox="0 0 628 265" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <defs>
          <clipPath id="mask11">
            <path
              d="M16 0C7.16344 0 0 7.16343 0 16V265C0 265 144.353 243.757 315.308 243.757C486.264 243.757 628 265 628 265V16C628 7.16344 620.837 0 612 0H16Z"
              fill="#FA85BD"
            />
          </clipPath>
        </defs>
        <image
          xlinkHref={ImagesService.transformUrlToProxyUrl(asset.desktop ?? '')}
          className="w-full h-auto"
          width="100%"
          height="100%"
          clipPath="url(#mask11)"
        />
      </svg>
    </div>
  );
};
